const SingleAppointment = ({ inputId, name }) => {
  return (
    <>
      <label
        htmlFor={inputId}
        className="relative flex p-2 items-center justify-center bg-[#f8f8f8] cursor-pointer border rounded-md overflow-hidden"
      >
        <input type="radio" id={inputId} hidden className="peer" name={name} />
        <div className="absolute w-full h-full left-0 top-0 rounded-md border  border-transparent peer-checked:border-[#e66553]"></div>
        <div className="time p-2 text-sm font-normal">
          <span className="from after:content-['-'] after:px-1">10:50AM</span>
          <span className="to">11:50AM</span>
        </div>
        {/* <span className="py-2 px-5 m-2 rounded-full text-[12px] font-medium border-2 peer-checked:bg-[#e66553] peer-checked:text-white">
          Select
        </span> */}
      </label>
    </>
  );
};

export default SingleAppointment;
